"use client"

import { ReceiptEuro } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ReceiptEuroIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ReceiptEuroIcon = component(Icon)({ as: ReceiptEuro })
